export default __webpack_public_path__ + "static/logo-6dbd0fc6503a00b33dd67fa8654db504.svg";